export const Theme = {
    colors: {
        primary: '#f9f9f9'
    }
}